import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";

import Button from "@khanacademy/wonder-blocks-button";
import {border, sizing} from "@khanacademy/wonder-blocks-tokens";

import signOutIcon from "@phosphor-icons/core/bold/sign-out-bold.svg";

export const LogoutButton = () => {
    return (
        <Button
            kind="secondary"
            size="medium"
            aria-label={t`Log out`}
            style={styles.logoutButton}
            href="/logout"
            endIcon={signOutIcon}
        >
            {t`Log out`}
        </Button>
    );
};

const styles = StyleSheet.create({
    logoutButton: {
        width: "fit-content",
        paddingInline: sizing.size_320,
        borderRadius: border.radius.radius_080,
        marginBlockStart: sizing.size_240,
    },
});
